import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const routes = [
    {
        path: "*",
        redirect: "/home",
    },
    //本地登录
    {
        path: "/home",
        component: () => import("./view/home.vue"),
        meta: {
            title: "",
        },
    },
    //待办
    {
        path: "/todo",
        component: () => import("./view/ToDo/index.vue"),
        meta: {
            title: "",
        },
    },
    //首页
    {
        path: "/index",
        component: () => import("./view/index"),
        meta: {
            title: "",
        },
    },
    //隐私
    {
        path: "/privacy",
        component: () => import("./view/privacy"),
        meta: {
            title: "",
        },
    },
    //我的
    {
        path: "/my",
        component: () => import("./view/my"),
        meta: {
            title: "",
        },
    },
    
    
];

// add route path
routes.forEach((route) => {
    route.path = route.path || "/" + (route.name || "");
});

const router = new Router({ routes });

router.beforeEach((to, from, next) => {
    const title = to.meta && to.meta.title;
    if (title) {
        document.title = title;
    }
    next();
});

export { router };
